<script>
    import { getContext } from 'svelte';
    import Button from 'components/Button';

    const { close } = getContext('simple-modal');

    const trinidadLink = 'https://www.fygaro.com/en/pb/2933de9e-e8f2-418f-bda3-65e585a3316d/';
    const barbadosLink = 'https://surepaybills.com/payment-locations-barbados/';

    function handleTrinidadClick() {
        window.open(trinidadLink, '_blank');
        close();
    }

    function handleBarbadosClick() {
        window.open(barbadosLink, '_blank');
        close();
    }

    function handleCancel(e) {
        e.preventDefault();
        close();
    }
</script>

<div class="modal">
    <div class="modal-content">
        <h2 class="modal-content__title">Make a Payment</h2>
        <p class="modal-content__desc">Select your location to proceed with your payment:</p>

        <div class="payment-options">
            <button class="payment-option" on:click={handleTrinidadClick}>
                <i class="fa-solid fa-location-dot payment-option__icon"></i>
                <div class="payment-option__content">
                    <h3 class="payment-option__title">Trinidad & Tobago</h3>
                    <p class="payment-option__text">For Trinidad customers, click here to make a payment</p>
                </div>
                <i class="fa-solid fa-arrow-right payment-option__arrow"></i>
            </button>

            <button class="payment-option" on:click={handleBarbadosClick}>
                <i class="fa-solid fa-location-dot payment-option__icon"></i>
                <div class="payment-option__content">
                    <h3 class="payment-option__title">Barbados</h3>
                    <p class="payment-option__text">For Barbados customers, click here to make a payment</p>
                </div>
                <i class="fa-solid fa-arrow-right payment-option__arrow"></i>
            </button>
        </div>
    </div>
    <div class="actions">
        <Button cancel onClick={handleCancel}>Cancel</Button>
    </div>
</div>

<style lang="scss">
    @use 'src/sass/base' as *;

    .modal-content {
        margin-bottom: em(60);
        padding: em(45) em(45) 0 em(45);

        &__title {
            margin-bottom: em(25);
            font-size: em(20);
            font-weight: $fw-bold;
            color: $color-primary;
        }

        &__desc {
            font-size: em(16);
            color: $color-gray-text;
            line-height: 1.25;
            margin-bottom: em(30);
        }
    }

    .payment-options {
        display: flex;
        flex-direction: column;
        gap: em(15);
    }

    .payment-option {
        display: flex;
        align-items: center;
        gap: em(15);
        padding: em(20) em(20);
        background: $color-white;
        border: 2px solid $color-gray-light;
        border-radius: em(8);
        cursor: pointer;
        transition: all 0.2s ease;
        text-align: left;
        width: 100%;

        &:hover {
            border-color: $color-primary;
            background: rgba(0, 126, 202, 0.02);
            transform: translateX(4px);
        }

        &__icon {
            font-size: em(24);
            color: $color-primary;
            flex-shrink: 0;
        }

        &__content {
            flex: 1;
            min-width: 0;
        }

        &__title {
            font-size: em(16);
            font-weight: $fw-bold;
            color: $color-black;
            margin-bottom: em(5);
        }

        &__text {
            font-size: em(14);
            color: $color-gray-text;
            line-height: 1.4;
        }

        &__arrow {
            font-size: em(18);
            color: $color-primary;
            flex-shrink: 0;
            transition: transform 0.2s ease;
        }

        &:hover &__arrow {
            transform: translateX(4px);
        }
    }

    .actions {
        padding: em(10) em(25);
        background: $color-gray-light;
        display: flex;
        flex-flow: column wrap;
        justify-content: center;
        align-items: center;
        width: auto;

        @include for-tablet-landscape-up {
            flex-flow: row nowrap;
            justify-content: flex-end;
        }
    }
</style>
